import { api } from "../lib/api";
import type { PlReport } from "./pl";

export type AccountingYearStatus = "open" | "closed";

export interface AccountingYear {
  id: string;
  start_date: string;
  end_date: string;
  status: AccountingYearStatus;
  closed_at: string | null;
  snapshot: PlReport | null;
  created_at: string;
  updated_at: string;
}

/** A year the user may close — enumerated server-side so the range always matches the
 * company's real accounting-year boundaries. `id` is null until the year is first closed. */
export interface AvailableYear {
  id: string | null;
  start_date: string;
  end_date: string;
  status: AccountingYearStatus;
  closed_at: string | null;
  is_current: boolean;
}

export function listAvailableAccountingYears(): Promise<AvailableYear[]> {
  return api.get<AvailableYear[]>("/api/accounting-years/available");
}

export function listAccountingYears(): Promise<AccountingYear[]> {
  return api.get<AccountingYear[]>("/api/accounting-years");
}

export function closeAccountingYear(startDate: string, endDate: string): Promise<AccountingYear> {
  return api.post<AccountingYear>("/api/accounting-years/close", {
    start_date: startDate,
    end_date: endDate,
  });
}

export function reopenAccountingYear(id: string): Promise<AccountingYear> {
  return api.post<AccountingYear>(`/api/accounting-years/${id}/reopen`, {});
}
